var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPenSolid = function SvgPenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.906 3.969A4.1 4.1 0 0 0 21 5.188L5.188 21l-.063.313-1.094 5.5-.312 1.468 1.469-.312 5.5-1.094.312-.062L26.813 11a4.075 4.075 0 0 0 0-5.812 4.1 4.1 0 0 0-2.907-1.22m0 1.906c.504 0 1.012.23 1.5.719.973.972.973 2.027 0 3l-.718.687-2.97-2.969.688-.718c.489-.489.996-.719 1.5-.719m-3.593 2.844 2.968 2.969L11.188 23.78a6.8 6.8 0 0 0-2.97-2.968ZM6.938 22.438a4.73 4.73 0 0 1 2.625 2.625l-3.282.656Z"
  })));
};
export default SvgPenSolid;